// extracted by mini-css-extract-plugin
module.exports = {"stats":"MarketStats-module--stats--1nHIB","total":"MarketStats-module--total--2NIM_","info":"MarketStats-module--info--3gUiK"};